module.exports = __webpack_public_path__ + "img/recommed-img7.0f0751c1.jpg";